/**
 * External dependencies
 */
import React from 'react';
import ReactDOM from 'react-dom';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import ReloadAPP from '@naruto/naruto-components/src/page/v1/Reload';

/**
 * Internal dependencies
 */
import MainAPP from '@naruto/bgdapp/src/components/App';
import createProvider from '@naruto/bgdapp/src/providers';
import Env from '@naruto/bgdapp/src/env';
import Debug from '@naruto/naruto-models/src/core/debug';
import getDebugData from '@naruto/bgdapp/src/base/debug';
import getReduxConfigData from '@naruto/bgdapp/src/base/redux';
import { initializeLangConfig } from '@naruto/bgdapp/src/langs';
import '@naruto/bgdapp/src/css/index.css';
import '@naruto/bgdapp/src/plugin';
import 'react-quill-new/dist/quill.snow.css';

async function initializeProcessEnv(): Promise<boolean> {
  const success = await Env.initializeFromNginx();
  return success;
}

async function enableDebug(): Promise<void> {
  const DebugLog = new Debug();
  if (Env.config.Debug) DebugLog.printInConsole(getDebugData(Env));
}

async function renderMainApp(): Promise<void> {
  const { Provider, initialStore } = createProvider(getReduxConfigData(Env));
  const nonce = document.head.querySelector('[property~=csp-nonce][content]')?.getAttribute('content') as string;
  const cache = createCache({
    key: 'naruto-app-prefix',
    nonce,
    prepend: true
  });
  ReactDOM.render(
    <Provider store={initialStore}>
      <CacheProvider value={cache}>
        <MainAPP />
      </CacheProvider>
    </Provider>,
    document.getElementById('root')
  );
}

async function renderLoadFailedApp(): Promise<void> {
  ReactDOM.render(<ReloadAPP />, document.getElementById('root'));
}

async function main(): Promise<void> {
  /* 初始化環境變數 */
  const initializeSuccess = await initializeProcessEnv();
  /* 初始化 APP 語系設定檔 */
  initializeLangConfig();
  /* 渲染 APP */
  if (initializeSuccess) {
    await renderMainApp();
  } else {
    await renderLoadFailedApp();
  }
  /* 開關 DEBUG */
  await enableDebug();
}

main();
